import { DefaultService } from '@/services/DefaultService';

export default class AreaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(area) {
        return this._http.post(`${this._env}/agro/area`, area, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/area/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/agro/area/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(page = 0, limit = 50, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/area.json?page=${page}&limit=${limit}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllByPropriedade(uuid, limit = 50, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/propriedade/${uuid}/area.json?limit=${limit}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    listAllByMultipleIdsPropriedades(uuidsPropriedades, limit = 50, page = 0, situacao = 2, ...params) {
        return this._http.post(`${this._env}/agro/propriedade/listbymultiplepropriedades.json?limit=${limit}&page=${page}&situacao=${situacao}&param=${params}`, uuidsPropriedades, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(...params) {
        // precisa da pesquisa e ORIGEMPDA
		return this._http.get(encodeURI(`${this._env}/agro/area/getcombo.json?param=${params}`), this._headers).then(res => {
            return res.body;
		}, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
		});
	}

}